import { useState } from 'react';
import useRecaptcha from './useRecaptcha';

const API = '/api';

/**
 * Hook reutilizable para suscripción al newsletter.
 * Captura automáticamente: browser, device, screen_size.
 */
export function useNewsletter() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(false);
  const { execute: execRecaptcha } = useRecaptcha();

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email || loading) return;

    setLoading(true);
    setMessage('');

    try {
      const ua = navigator.userAgent;
      const browser = (() => {
        if (ua.includes('Chrome') && !ua.includes('Edg')) return 'Chrome';
        if (ua.includes('Safari') && !ua.includes('Chrome')) return 'Safari';
        if (ua.includes('Firefox')) return 'Firefox';
        if (ua.includes('Edg')) return 'Edge';
        return 'Otro';
      })();
      const device = (() => {
        if (/iPhone/i.test(ua)) return 'iPhone';
        if (/iPad/i.test(ua)) return 'iPad';
        if (/SM-|Samsung/i.test(ua)) return 'Samsung';
        if (/Xiaomi|Redmi|POCO/i.test(ua)) return 'Xiaomi';
        if (/Huawei|HONOR/i.test(ua)) return 'Huawei';
        if (/OPPO/i.test(ua)) return 'OPPO';
        if (/vivo/i.test(ua)) return 'Vivo';
        if (/Pixel/i.test(ua)) return 'Google Pixel';
        if (/Android/i.test(ua)) return 'Android';
        if (/Macintosh|Mac OS/i.test(ua)) return 'Mac';
        if (/Windows/i.test(ua)) return 'Windows';
        if (/Linux/i.test(ua)) return 'Linux';
        if (/CrOS/i.test(ua)) return 'ChromeOS';
        return navigator.platform || 'Desconocido';
      })();

      const recaptchaToken = await execRecaptcha('newsletter');

      const res = await fetch(`${API}/newsletter/suscribir`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          email,
          browser,
          device,
          screen_size: `${window.innerWidth}x${window.innerHeight}`,
          recaptcha_token: recaptchaToken,
        }),
      });

      const data = await res.json();
      if (data.exito) {
        setSuccess(true);
        setMessage(data.mensaje);
        setEmail('');
      } else {
        setMessage(data.mensaje || 'Error al suscribir.');
      }
    } catch {
      setMessage('Error de conexión. Intenta de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  return { email, setEmail, loading, message, success, subscribe };
}
